// extracted by mini-css-extract-plugin
export default {"avatar":"avatar--PHg0d"};